import React, { useState, useEffect, Fragment, useContext } from "react";
import { Form, Container, Row, Col, Alert } from "react-bootstrap";
import axios from "axios";
import Preloader from "../../shared/PreLoaders";
import { Authorization } from "../../Context/Authorization";
const JoinSHG = () => {
  const [selectedVFC, setSelectedVFC] = useState("");
  const [selectedSHG, setSelectedSHG] = useState("");
  const [selectedSHGName, setSelectedSHGName] = useState("");
  const [members, setMembers] = useState([]);
  const [shgData, setShgData] = useState([]);
  const [newMembers, setNewMembers] = useState([]);
  const [designation, setDesignation] = useState("Member");
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const [vfcData, setVfcData] = useState([]);
  const [selectedMember, setSelectedMember] = useState("");
  const [shgMembers, setShgMembers] = useState([]);
  const [alreadyAdded, setAlreadyAdded] = useState([]);
  const [loading, setLoading] = useState(true);
  const Api = process.env.REACT_APP_API;

  useEffect(() => {
    setLoading(true);
    const fetchVfc = async () => {
      try {
        const config = Authorization();
        const response = await axios.get(`${Api}/api/vfcs`, config);
        const data = response.data.vfcs;
        setVfcData(data);
      } catch (error) {
        console.log("Error fetching Data", error);
      }
      setLoading(false);
    };

    fetchVfc();
  }, [Api]);

  const fetchSHGs = async (vfcId) => {
    setLoading(true);
    try {
      const config = Authorization();
      const response = await axios.post(
        `${Api}/api/shgs/getShgsByVFC`,
        {
          vfcId,
        },
        config
      );
      if (response.status !== 200) throw new Error("Error fetching SHG data");
      const data = response.data.shgs || [];
      setShgData(data.filter((shg) => shg && shg.name));
    } catch (error) {
      console.log("Error fetching SHGs", error);
      setError("Failed to fetch SHG names. Please try again.");
    }
    setLoading(false);
  };

  const fetchShgMemberByShgId = async (id) => {
    try {
      const config = Authorization();
      const response = await axios.post(
        `${Api}/api/shgMember/members`,
        {
          shgId: id,
        },
        config
      );
      if (response.status === 200) {
        const members = response.data.members || [];
        const validMembers = members.filter(
          (item) => item?.member && item.member.name
        );
        setShgMembers(validMembers);
      }
    } catch (error) {
      console.error("Error fetching SHG members", error);
    }
  };

  const fetchMembers = async (vfcId) => {
    setLoading(true);
    setMembers([]);
    setError(null);

    if (vfcId) {
      try {
        const config = Authorization();
        const response = await axios.get(
          `${Api}/api/members/getMembersByVFC/${vfcId}`,
          config
        );
        if (response.status !== 200) throw new Error("Error fetching members");
        const data = response.data.members;
        setMembers(data);
      } catch (error) {
        console.log("Error fetching members", error);
        setError("Failed to fetch members. Please try again.");
      }
    }
    setLoading(false);
  };

  const handleVfcSelect = (e) => {
    const vfcId = e.target.value;
    setSelectedVFC(vfcId);
    fetchMembers(vfcId);
    fetchSHGs(vfcId);
  };

  const handleShgSelect = (e) => {
    const shgId = e.target.value;
    const shgName = e.target.options[e.target.selectedIndex]?.text || "Unknown";
    setSelectedSHG(shgId);
    setSelectedSHGName(shgName);
    if (shgId) {
      fetchShgMemberByShgId(shgId);
    }
  };

  const handleMemberSelect = (e) => {
    setSelectedMember(e.target.value);
  };

  const handleDesignationChange = (e) => {
    setDesignation(e.target.value);
  };

  const handleAddMember = () => {
    if (selectedMember) {
      const member = members.find((m) => m._id === selectedMember);
      if (member) {
        const isAlreadyAdded =
          alreadyAdded &&
          alreadyAdded.some(
            (addedMember) =>
              addedMember.member && addedMember.member._id === member._id
          );

        const isInNewMembers = newMembers.some(
          (newMember) => newMember._id === member._id
        );

        if (isAlreadyAdded || isInNewMembers) {
          setError("Member is already added.");
          return;
        }

        setNewMembers([...newMembers, member]);
        setError(null);
      }
      setSelectedMember("");
    }
  };

  const handleSave = async () => {
    if (!selectedSHG || newMembers.length === 0) {
      setError("Please select an SHG and add members.");
      return;
    }

    const payload = {
      shg: selectedSHG,
      member: newMembers.map((member) => member._id),
      designation,
    };

    try {
      const config = Authorization();
      const response = await axios.post(`${Api}/api/shgMember`, payload, {
        headers: {
          "Content-Type": "application/json",
          ...config.headers,
        },
      });
      if (response.status !== 201) throw new Error("Error saving members");
      setSuccess("Members saved successfully");
      setError(null);
      fetchShgMemberByShgId(selectedSHG);
      setNewMembers([]);
    } catch (error) {
      console.log("Error saving members", error);
      setError("Failed to save members. Please try again.");
      setSuccess(null);
    }
  };

  const availableMembers = members.filter(
    (member) => !newMembers.some((newMember) => newMember._id === member._id)
  );

  return (
    <div>
      <Preloader loading={loading} />
      <div className="page-header">
        <h3 className="page-title"> Join SHG Form </h3>
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <a href="!#" onClick={(event) => event.preventDefault()}>
                VFC
              </a>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              Join SHG Form
            </li>
          </ol>
        </nav>
      </div>

      <Container>
        <>
          {error && <Alert variant="danger">{error}</Alert>}
          {success && <Alert variant="success">{success}</Alert>}
          <div className="col-md-12 grid-margin stretch-card">
            <div className="card">
              <div className="card-body">
                <p className="card-description">Join SHG Form</p>
                <Form>
                  <Form.Group as={Row} controlId="vfcSelect">
                    <Form.Label column sm={2}>
                      Select VFC
                    </Form.Label>
                    <Col sm={10}>
                      <Form.Control
                        as="select"
                        onChange={handleVfcSelect}
                        value={selectedVFC}
                      >
                        <option value="">Select VFC</option>
                        {vfcData.map((vfc) => (
                          <option key={vfc._id} value={vfc._id}>
                            {vfc.vfcName}
                          </option>
                        ))}
                      </Form.Control>
                    </Col>
                  </Form.Group>
                  <Form.Group as={Row} controlId="shgSelect">
                    <Form.Label column sm={2}>
                      Select SHG
                    </Form.Label>
                    <Col sm={10}>
                      <Form.Control
                        as="select"
                        onChange={handleShgSelect}
                        value={selectedSHG}
                      >
                        <option value="">Select SHG</option>
                        {shgData.length > 0 &&
                          shgData.map((shg) => (
                            <option key={shg._id} value={shg._id}>
                              {shg.name}
                            </option>
                          ))}
                      </Form.Control>
                    </Col>
                  </Form.Group>

                  <Form.Group as={Row} controlId="designationSelect">
                    <Form.Label column sm={2}>
                      Designation
                    </Form.Label>
                    <Col sm={10}>
                      <Form.Control
                        as="select"
                        onChange={handleDesignationChange}
                        value={designation}
                      >
                        <option value="Member">Member</option>
                        <option value="President">President</option>
                      </Form.Control>
                    </Col>
                  </Form.Group>

                  {selectedVFC && (
                    <Fragment>
                      <Form.Group as={Row} controlId="newMember">
                        <Form.Label column sm={2}>
                          Add Member
                        </Form.Label>
                        <Col sm={8}>
                          <Form.Control
                            as="select"
                            value={selectedMember}
                            onChange={handleMemberSelect}
                          >
                            <option value="">Select Member</option>
                            {availableMembers.map((member) => (
                              <option key={member._id} value={member._id}>
                                {member.name || "Unnamed Member"}
                              </option>
                            ))}
                          </Form.Control>
                        </Col>
                        <Col sm={2}>
                          <button
                            type="button"
                            className="btn btn-inverse-success"
                            onClick={handleAddMember}
                          >
                            Create New
                          </button>
                        </Col>
                      </Form.Group>

                      {newMembers.length > 0 && (
                        <Fragment>
                          <div className="card">
                            <div className="card-body">
                              <p className="card-description">
                                Selected Members
                              </p>

                              <div className="row icons-list">
                                <div className="table-responsive">
                                  <table className="table">
                                    <thead>
                                      <tr>
                                        <th>Name</th>
                                        <th>Designation</th>
                                        <th>Status</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {newMembers.map((member, index) => (
                                        <tr key={index}>
                                          <td>
                                            {member.name || "Unnamed Member"}
                                          </td>
                                          <td>{designation}</td>
                                          <td
                                            style={{
                                              color:
                                                member.status === "A"
                                                  ? "green"
                                                  : "red",
                                            }}
                                          >
                                            {member.status === "A"
                                              ? "Active"
                                              : "Inactive"}
                                          </td>
                                        </tr>
                                      ))}
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            </div>
                          </div>
                        </Fragment>
                      )}
                    </Fragment>
                  )}
                  <button
                    type="button"
                    className="btn btn-outline-primary btn-icon-text mt-3"
                    onClick={handleSave}
                  >
                    <i className="mdi mdi-file-check btn-icon-prepend"></i>
                    Save Members
                  </button>
                  <button className="btn btn-light mt-3">Cancel</button>
                </Form>
              </div>
            </div>
          </div>

          {shgMembers.length > 0 && (
            <Fragment>
              <div className="card">
                <div className="card-body">
                  <p className="card-description">
                    Members Already in SHG {selectedSHGName}
                  </p>
                  <div className="row icons-list">
                    <div className="table-responsive">
                      <table className="table">
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>Name</th>
                            <th>Status</th>
                            <th>Designation</th>
                          </tr>
                        </thead>
                        <tbody>
                          {shgMembers.map((shgMember, index) => (
                            <tr key={index}>
                              <td>{index + 1}</td>
                              <td>{shgMember.member.name}</td>
                              <td className="text-success">
                                {shgMember.member.status
                                  ? shgMember.member.status
                                  : "Active"}
                              </td>
                              <td>{shgMember.designation}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </Fragment>
          )}
        </>
      </Container>
    </div>
  );
};

export default JoinSHG;
